import { useLoginQuery } from "@/queries/auth.queries";
import { QRBarcodeScanner } from "@/components/scanner";
import { Link } from "react-router-dom";

export function ScanBadge() {
  const login = useLoginQuery(true);

  function handleLogin(code: string) {
    login.mutate({ grantType: "Password", barcode: code });
  }

  return (
    <div id="body" className="about-area space__bottom--r120">
      <div className="container">
        <div className="row align-items-center row-25">
          <div className="col-md-6 order-2 order-md-1">
            <div className="about-content">
              <div className="section-title space__bottom--25">
                <h2 className="section-title__title mb-2">Scan your badge</h2>
                <span>
                  Or click{" "}
                  <Link to="manual" className="link-primary">
                    Here
                  </Link>{" "}
                  to type your badge number manually.
                </span>
              </div>
              <div className="barcode-scan border">
                <QRBarcodeScanner onScan={handleLogin} />
              </div>
              {login.isError && <p className="alert alert-danger mt-3">User not found, please re-scan.</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
